import * as types from './mutation-types'

const mutations = {
  // [types.SET_USERNAME] (state, user) {
  //   state.username = user
  // },
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.SET_STEPACTIVEINDEX] (state, index) {
    state.stepActiveIndex = index
  },
  [types.SET_LOGIN_POP_STATE] (state, status) {
    state.showLogin = status
  },
  [types.SET_CHECKED_EMAIL] (state, email) {
    state.checkedEmail = email
  },
  [types.SET_EMAIL_BIND] (state, isBind) {
    state.isEmailBind = isBind
  },
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SET_UID] (state, uid) {
    state.uid = uid
  },
  [types.SET_REDIRECT] (state, url) {
    state.redirect = url
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js